module.exports = __webpack_public_path__ + "assets/chart4.1.png?31dece491eab95b945bcf6b73aa52a11";